import type { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { useAuthStore } from "@/features/auth/store/auth.store";
import { ManageContractorProfilePage } from "@/features/contractor-profile/pages/manage-contractor-profile";
import { ManagePortfolioPage } from "./pages/manage-portfolio";
import { PublicPortfolioPage } from "./pages/public-portfolio";

function PortfolioSwitcher() {
	const { getUserType } = useAuthStore();
	const userType = getUserType();
	if (userType === "contractor") {
		return <ManageContractorProfilePage />;
	}
	return <ManagePortfolioPage />;
}

export const portfolioRoutes: RouteObject[] = [
	{
		path: "/portfolio",
		element: (
			<ProtectedRoute requireUserType={["designer", "contractor"]}>
				<PortfolioSwitcher />
			</ProtectedRoute>
		),
	},
	{
		path: "/designer/portfolio",
		element: (
			<ProtectedRoute requireUserType="designer">
				<ManagePortfolioPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/contractor/portfolio",
		element: (
			<ProtectedRoute requireUserType="contractor">
				<ManageContractorProfilePage />
			</ProtectedRoute>
		),
	},
	{
		path: "/portfolio/:slug",
		element: <PublicPortfolioPage />,
	},
];
